import React, { useState } from 'react';
import { NavLink, Link, Outlet } from 'react-router-dom';
import {
  FaTachometerAlt, FaBoxOpen, FaPuzzlePiece, FaTicketAlt, FaUsers, FaCloud, FaArrowLeft, FaCode, FaBell, FaBars, FaEnvelope, FaDatabase, FaRobot, FaWhatsapp, FaClipboardList, FaStream, FaUserTag, FaNetworkWired
} from 'react-icons/fa';

const navItems = [
  { to: "/admin/dashboard", label: "Dashboard", icon: FaTachometerAlt },
  { to: "/admin/plans", label: "Manage Plans", icon: FaBoxOpen },
  { to: "/admin/features", label: "Manage Features", icon: FaPuzzlePiece },
  { to: "/admin/coupons", label: "Manage Coupons", icon: FaTicketAlt },
  { to: "/admin/users", label: "Manage Users", icon: FaUsers },
  { to: "/admin/subscriptions", label: "Subscriptions", icon: FaTicketAlt },
  { to: "/admin/assign-plan", label: "Assign Plan", icon: FaUserTag },
  { to: "/admin/storage", label: "Cloud Storage", icon: FaCloud },
  { to: "/admin/proxy-pool", label: "Proxy Pool", icon: FaNetworkWired },
  { to: "/admin/developer", label: "API Documentation", icon: FaCode },
  { to: "/admin/webhook", label: "Webhooks", icon: FaBell },
  { to: "/admin/email-templates", label: "Email Templates", icon: FaEnvelope },
  { to: "/admin/automations", label: "Automations", icon: FaRobot },
  { to: "/admin/session", label: "Admin Session", icon: FaWhatsapp },
  { to: "/admin/session-logs", label: "Session Logs", icon: FaStream },
  { to: "/admin/data", label: "Data Management", icon: FaDatabase },
  { to: "/admin/changelog", label: "Changelog", icon: FaClipboardList },
];

const NavItem = ({ to, label, icon: Icon, onClick }) => (
  <NavLink
    to={to}
    onClick={onClick}
    className={({ isActive }) =>
      `flex items-center gap-2.5 rounded-md px-3 py-2 text-sm font-semibold transition-colors ${
        isActive
          ? 'bg-blue-950 text-white'
          : 'text-slate-400 hover:bg-slate-900 hover:text-white'
      }`
    }
  >
    <Icon size={14} />
    {label}
  </NavLink>
);

export default function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex min-h-screen bg-surface-bg">
      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div className="fixed inset-0 bg-black/30 z-40 md:hidden" onClick={() => setSidebarOpen(false)} />
      )}

      {/* Sidebar */}
      <aside className={`${sidebarOpen ? 'fixed inset-y-0 left-0 z-50' : 'hidden'} w-[252px] flex-shrink-0 flex-col border-r border-slate-800 bg-slate-950 p-4 md:relative md:flex`}>
        <Link to="/admin/dashboard" className="mb-5 flex h-12 items-center border-b border-slate-800 px-3 pb-4">
          <img src="/walytic-logo-white.png" alt="Walytic" className="h-7 w-auto object-contain" />
        </Link>
        <p className="mb-2 px-3 text-[10px] font-bold uppercase tracking-[0.14em] text-slate-600">Administration</p>
        <nav className="flex-1 space-y-1">
          {navItems.map(item => (
            <NavItem key={item.to} {...item} onClick={() => setSidebarOpen(false)} />
          ))}
        </nav>
        <Link
          to="/dashboard"
          onClick={() => setSidebarOpen(false)}
          className="mt-4 flex items-center gap-2.5 border-t border-slate-800 px-3 pt-4 text-sm font-semibold text-slate-400 transition-colors hover:text-white"
        >
          <FaArrowLeft size={12} /> Back to Dashboard
        </Link>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-y-auto flex flex-col">
        {/* Mobile header bar */}
        <div className="flex items-center gap-3 border-b border-surface-border bg-surface-card px-4 py-3 md:hidden">
          <button onClick={() => setSidebarOpen(true)} className="text-ink-primary">
            <FaBars size={18} />
          </button>
          <span className="font-semibold text-ink-primary">Admin Panel</span>
        </div>

        <div className="flex-1 p-5 md:p-7">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
